import { createActions } from "redux-actions";

export const SET_IS_MOBILE_SCREEN = "SET_IS_MOBILE_SCREEN";

export const { setIsMobileScreen } = createActions({}, SET_IS_MOBILE_SCREEN);
